import { Phone } from "lucide-react";

export default function EmergencyBanner() {
  return (
    <div
      className="w-full bg-[#0B1B33] text-[#FAF7F2] text-sm py-2.5 px-4 flex items-center justify-center gap-3 border-b border-[#B08D5B]/30"
      data-testid="emergency-banner"
    >
      <span className="inline-flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-[#DC2626] animate-pulse" />
        <span className="label-overline text-[10px] text-[#D4B888]">24/7 Emergency</span>
      </span>
      <span className="hidden sm:inline text-stone-300 font-body text-[13px]">
        Burst pipes · electrical faults · urgent repairs
      </span>
      <a
        href="tel:+14168264590"
        className="inline-flex items-center gap-1.5 text-[#FAF7F2] hover:text-[#D4B888] transition-colors font-semibold underline underline-offset-4 decoration-[#B08D5B]/60"
        data-testid="emergency-call-link"
      >
        <Phone className="w-3.5 h-3.5" />
        +1 416 826 4590
      </a>
    </div>
  );
}
